import { Component, input } from '@angular/core';

@Component({
    selector: 'app-main-spinner',
    templateUrl: './main-spinner.component.html',
    styleUrl: './main-spinner.component.scss',
    standalone: false
})
export class MainSpinnerComponent {
  public size = input<string | number>();
}
